import gql from "graphql-tag";

export const getRiotVerificationIcon = `requestRiotVerificationCode {
    iconId
  }`;

const GET_RIOT_VERIFICATION_ICON = gql`
    query requestRiotVerificationCode {
        ${getRiotVerificationIcon}
    }
`;

export default GET_RIOT_VERIFICATION_ICON;
